import Component from '@ember/component';
import { action, computed, get, getProperties } from '@ember/object';
import { sort } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';

/*
  attrs
  - funds
  - userFunds - list of current user funds (null for new user)

  actions
  - onSave(selectedItems)
    - selectedItems = [{ fund: '', userFund: '' })
      - userFund will be null if it didn't exist before
*/
export default Component.extend({
  q: '',

  list: computed('funds', 'userFunds', function () {
    let { funds, userFunds } = getProperties(this, 'funds', 'userFunds');
    let userFundsByFundId = {};
    if (userFunds != null) {
      userFunds.forEach((userFund) => {
        userFundsByFundId[get(userFund, 'fundId')] = userFund;
      });
    }
    return funds.map((fund) => {
      let userFund = userFundsByFundId[get(fund, 'id')];
      return {
        fund: fund,
        userFund: userFund,
        isSelected: userFund != null,
      };
    });
  }),
  sortBy: ['fund.name:asc'],
  sortedList: sort('list', 'sortBy'),

  filteredList: computed('q', 'sortedList', function () {
    let { q, sortedList } = getProperties(this, 'q', 'sortedList');
    if (isEmpty(q)) {
      return sortedList.filter((item) => {
        return get(item, 'fund.active');
      });
    }
    q = q.toLowerCase();
    return sortedList.filter((item) => {
      if (get(item, 'fund.active') === false) {
        return false;
      }
      return get(item, 'fund.nameLowerCase').indexOf(q) >= 0;
    });
  }),

  selectedList: computed('sortedList.@each.isSelected', function () {
    let sortedList = this.sortedList;
    return sortedList.filter((item) => {
      return get(item, 'isSelected');
    });
  }),

  save: action(function () {
    this.onSave(this.selectedList);
  }),
});
